import { Component } from '@angular/core';
import { AmmunitionStockEventService } from 'assets-service';
import { Observable } from 'rxjs';
import { BaseEmailTemplatesComponent, TemplateParameters } from '../../base-email-templates-landing-page.component';


@Component({
  selector: 'ranger-ammunition-issue-email-template',
  templateUrl: './ranger-ammunition-issue-email-template.component.html',
  styleUrls: ['./ranger-ammunition-issue-email-template.component.scss']
})
export class RangerAmmunitionIssueEmailTemplatesComponent extends BaseEmailTemplatesComponent {

  constructor(private ammunitionStockEventService: AmmunitionStockEventService) {
    super();
  }

  protected getExampleTemplateParameters(backgroundServiceCall?: boolean): Observable<TemplateParameters> {
    return this.ammunitionStockEventService.exampleRangerAmmunitionIssueTemplateParameters(backgroundServiceCall);
  }


}
